import { render } from "./SelectButton.vue?vue&type=template&id=0fb2c629&scoped=true"
import script from "./SelectButton.vue?vue&type=script&lang=js"
export * from "./SelectButton.vue?vue&type=script&lang=js"

import "./SelectButton.vue?vue&type=style&index=0&id=0fb2c629&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0fb2c629"

export default script